// import moment from 'moment';
import streaming from '@/data/static/streaming';

const landing = {
  namespaced: true,
  state: {
    url: 'https://youtu.be/Tdn9bxg5Ge8',
    bannerHeight: 0,
    display: {
      timer: false,
      banner: false,
      button: false,
      streaming: false,
      over: false
    },
    bannerClosed: false,
    streamingDate: null,
    streamingDates: { ...streaming.dates.prod },
    timer: {
      days: null,
      hours: null,
      minutes: null,
      seconds: null
    }
  },
  mutations: {
    setBannerHeight(state, height) {
      state.bannerHeight = height;
    },
    closeBanner(state) {
      localStorage.setItem('banner-closed', 'true');
      state.bannerClosed = true;
    }
  },
  // actions: {
  //   setDate({ state }) {
  //     /* eslint-disable */
  //     const currentDate = moment();

  //     // Check start first date
  //     let date = state.streamingDates.first.start;
  //     let duration = moment.duration(date.diff(currentDate));

  //     if (duration > 0) {
  //       state.streamingDate = date;
  //       return;
  //     }

  //     // Check end first date
  //     date = state.streamingDates.first.end;
  //     duration = moment.duration(date.diff(currentDate));

  //     if (duration > 0) {
  //       state.display.streaming = true;
  //       state.display.button = true;
  //       return;
  //     }

  //     // Check start second date
  //     date = state.streamingDates.second.start;
  //     duration = moment.duration(date.diff(currentDate));

  //     if (duration > 0) {
  //       state.streamingDate = date;
  //       return;
  //     }

  //     // Check end second date
  //     date = state.streamingDates.second.end;
  //     duration = moment.duration(date.diff(currentDate));

  //     if (duration > 0) {
  //       state.display.streaming = true;
  //       state.display.button = true;
  //       return;
  //     }

  //     // Check start third date
  //     date = state.streamingDates.third.start;
  //     duration = moment.duration(date.diff(currentDate));

  //     if (duration > 0) {
  //       state.streamingDate = date;
  //       return;
  //     }

  //     // Check end third date
  //     date = state.streamingDates.third.end;
  //     duration = moment.duration(date.diff(currentDate));

  //     if (duration > 0) {
  //       state.display.streaming = true;
  //       state.display.button = true;
  //       return;
  //     }

  //     state.display.timer = false;
  //     state.display.banner = false;
  //     state.display.streaming = false;
  //     state.display.button = false;
  //     state.display.over = true;
  //   },
  //   updateTimer({ state, dispatch }) {
  //     if (!state.display.timer || state.display.streaming) {
  //       return;
  //     }

  //     const date = moment();
  //     const duration = moment.duration(state.streamingDate.diff(date));

  //     if (duration._milliseconds < 0) {
  //       state.display.streaming = true;
  //       return;
  //     }

  //     /* eslint-disable */
  //     state.timer.days = duration._data.days < 10 ? `0${duration._data.days}` : duration._data.days;
  //     state.timer.hours = duration._data.hours < 10 ? `0${duration._data.hours}` : duration._data.hours;
  //     state.timer.minutes = duration._data.minutes < 10 ? `0${duration._data.minutes}` : duration._data.minutes;
  //     state.timer.seconds = duration._data.seconds < 10 ? `0${duration._data.seconds}` : duration._data.seconds;

  //     if (duration._milliseconds < 900000) {
  //       state.display.button = true;
  //     }

  //     setTimeout(() => {
  //       dispatch('updateTimer');
  //     }, 1000);
  //   }
  // }
};

export default landing;
